import { createContext, useContext, useMemo } from 'react'
import {
  DEFAULT_SERVICE_THEME,
  getRouteServiceTheme,
  getServiceTheme,
  getServiceThemeKey,
} from '@/utils/service-theme'

const PageThemeContext = createContext(getServiceTheme(DEFAULT_SERVICE_THEME))

export function PageThemeProvider({ children, pathname, theme }) {
  const activeThemeKey = getServiceThemeKey(theme || getRouteServiceTheme(pathname))
  const value = useMemo(() => getServiceTheme(activeThemeKey), [activeThemeKey])

  return (
    <PageThemeContext.Provider value={value}>
      {children}
    </PageThemeContext.Provider>
  )
}

export function usePageTheme(explicitTheme) {
  const inheritedTheme = useContext(PageThemeContext)

  if (!explicitTheme) return inheritedTheme

  return getServiceTheme(explicitTheme)
}
